import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from 'components/user/AuthContext';
import { ReferrerProvider } from 'components/layout/ReferrerContext';
import Header from 'components/layout/Header';
import TwutsList from 'components/twuts/TwutsList';
import TwutThread from 'components/twuts/TwutThread';
import LoginForm from 'components/user/LoginForm';
import RegisterForm from 'components/user/RegisterForm';
import EditProfile from 'components/user/EditProfile';

const queryClient = new QueryClient();

export default function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ReferrerProvider>
          <AuthProvider>
            <div className="container mx-auto max-w-4xl px-4 min-h-screen">
              <Header />
              <Routes>
                <Route path="/" element={<TwutsList />} />
                <Route path="/:username" element={<TwutsList />} />
                <Route path="/:username/replies" element={<TwutsList />} />
                <Route path="/twuts/following" element={<TwutsList />} />
                <Route path="/twuts/:twutId" element={<TwutThread />} />
                <Route path="/login" element={<LoginForm />} />
                <Route path="/register" element={<RegisterForm />} />
                <Route path="/profile/edit" element={<EditProfile />} />
              </Routes>
            </div>
          </AuthProvider>
        </ReferrerProvider>
      </Router>
    </QueryClientProvider>
  );
}